// extracted by mini-css-extract-plugin
export var backButton = "index-module--backButton--2y6O0";
export var icon = "index-module--icon--mUKq2";